import React, { createContext, useContext, useState } from 'react';
import {
  GlobalSettings,
  GlobalSettingsContextType,
} from '../types/global.types';

import moment from 'moment-timezone';

// Create the context
const GlobalSettingsContext = createContext<GlobalSettingsContextType>({
  settings: {
    timeZone: {
      current: '',
      utcOffset: 0,
      userLocale: '',
    },
    // default to 24 hours ago and now
    datePicker: {
      start: moment.utc().subtract(24, 'hours').toISOString(),
      end: moment.utc().toISOString(),
    },
  },
  setSettings: () => {},
});

// Create the provider component
export const GlobalSettingsProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [settings, setSettings] = useState<GlobalSettings>({
    timeZone: {
      current: Intl.DateTimeFormat().resolvedOptions().timeZone,
      utcOffset: new Date().getTimezoneOffset(),
      userLocale: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    datePicker: {
      start: moment.utc().subtract(24, 'hours').toISOString(),
      end: moment.utc().toISOString(),
    },
  });

  return (
    <GlobalSettingsContext.Provider value={{ settings, setSettings }}>
      {children}
    </GlobalSettingsContext.Provider>
  );
};

// Custom hook to use the GlobalSettingsContext
export const useGlobalSettings = () => {
  return useContext(GlobalSettingsContext);
};
